/**
 * REF-2 — the ONE route every refund KPI opens.
 *
 * Kept in its own module (rather than inside `RefundsDrillPage`) so a report screen can
 * build the link without importing the page component, which would defeat lazy-loading it.
 *
 * The period, outlet and sales-source travel in the query string rather than in router
 * state: state is lost on refresh and cannot be shared, and a refunds drill is exactly the
 * kind of screen an operator pastes into a message to their accountant.
 */
import { REPORTS_BASE } from '../paths';
import type { RefundOrigin } from './RefundsDrillPage';

export interface RefundsLinkParams {
    origin: RefundOrigin;
    /** The originating report's active preset, e.g. 'Today' | '7D' | 'This Month'. */
    dateFilter?: string;
    /** Resolved range. Sent alongside the preset so the page never re-resolves the period. */
    startDate?: string;
    endDate?: string;
    /** The sales-source toggle, carried through unchanged. */
    source?: 'overall' | 'direct' | 'thirdparty';
    /** Outlet, when the originating report is not on the active branch. */
    locationId?: string;
}

export const REFUNDS_ROUTE = `${REPORTS_BASE}/refunds`;

export function refundsPath(p: RefundsLinkParams): string {
    const q = new URLSearchParams();
    q.set('origin', p.origin);
    if (p.dateFilter) q.set('dateFilter', p.dateFilter);
    if (p.startDate) q.set('from', p.startDate);
    if (p.endDate) q.set('to', p.endDate);
    if (p.source) q.set('source', p.source);
    if (p.locationId) q.set('locationId', p.locationId);
    return `${REFUNDS_ROUTE}?${q.toString()}`;
}
